// Module
var code = "<h2 id=\"in-repaymentreview-the-available-repayment-plans\">In Repayment&mdash;Review the Available Repayment Plans</h2> <p>Choose between IBR plans or fixed monthly payments over a set period. </p> ";
// Exports
export default code;